import Electronics from "../assets/images/Electronics.png";
import FabricatedMetalProducts from "../assets/images/FabricatedMetalProducts.png";
import Papers from "../assets/images/Papers.png";
import FoodAndKindredProducts from "../assets/images/FoodAndKindredProducts.png";
import Rubber from "../assets/images/Rubber.png";
import TextileMillProducts from "../assets/images/TextileMillProducts.png";
import IndustrialAndCommercial from "../assets/images/IndustrialAndCommercial.png";
import Apparel from "../assets/images/Apparel.png";
import MetalIndustries from "../assets/images/MetalIndustries.png";
import Transportation from "../assets/images/Transportation.png";

import FoodKindredProductsIcon from "../components/Icons/FoodKindredProductsIcon";
import FabricatedMetalProductsIcon from "../components/Icons/FabricatedMetalProductsIcon";
import PaperAlliedProductsIcon from "../components/Icons/PaperAlliedProductsIcon";
import IndustrialCommercialMachineryComputerEquipmentIcon from "../components/Icons/IndustrialCommercialMachineryComputerEquipmentIcon";
import TextileMillProductsIcon from "../components/Icons/TextileMillProductsIcon";
import TransportationEquipmentIcon from "../components/Icons/TransportationEquipmentIcon";
import ApparelFinishedProductsIcon from "../components/Icons/ApparelFinishedProductsIcon";
import PrimaryMetalIndustriesIcon from "../components/Icons/PrimaryMetalIndustriesIcon";
import RubberMiscellaneousPlasticProductsIcon from "../components/Icons/RubberMiscellaneousPlasticProductsIcon";
import ElectronicEquipmentComponentsIcon from "../components/Icons/ElectronicEquipmentComponentsIcon";


export const BALANCE_SHEET = "Balance Sheet";
export const PROFIT_LOSS_STATEMENT = "Income Statement";
export const ACTUAL_RESULT = "actualResult";

export const AGENCY_TABS = {
  CLIENT_BACKGROUND: "CLIENT_BACKGROUND",
  SEGMENT_RISK: "SEGMENT_RISK",
  COMPETITIVE_RISK: "COMPETITIVE_RISK",
  RISK_MODELLING: "RISK_MODELLING",
};

export const INDUSTRY_ICONS = {
  "Electronic & Other Electrical Equipment & Components": Electronics,
  "Fabricated Metal Products": FabricatedMetalProducts,
  "Paper and Allied Products": Papers,
  "Food and Kindred Products": FoodAndKindredProducts,
  "Rubber and Miscellaneous Plastic Products": Rubber,
  "Textile Mill Products": TextileMillProducts,
  "Industrial and Commercial Machinery and Computer Equipment":
    IndustrialAndCommercial,
  "Apparel, Finished Products from Fabrics & Similar Materials": Apparel,
  "Primary Metal Industries": MetalIndustries,
  "Transportation Equipment": Transportation,
};

export const SECTOR_ICONS = {
  "Electronic & Other Electrical Equipment & Components": ElectronicEquipmentComponentsIcon,
  "Fabricated Metal Products": FabricatedMetalProductsIcon,
  "Paper and Allied Products": PaperAlliedProductsIcon,
  "Food and Kindred Products": FoodKindredProductsIcon,
  "Rubber and Miscellaneous Plastic Products": RubberMiscellaneousPlasticProductsIcon,
  "Textile Mill Products": TextileMillProductsIcon,
  "Industrial and Commercial Machinery and Computer Equipment":
    IndustrialCommercialMachineryComputerEquipmentIcon,
  "Apparel, Finished Products from Fabrics & Similar Materials": ApparelFinishedProductsIcon,
  "Primary Metal Industries": PrimaryMetalIndustriesIcon,
  "Transportation Equipment": TransportationEquipmentIcon,
};
